import { Component, OnInit, Type } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {
  FieldType,
  FieldTypeConfig,
  FormlyFieldConfig,
  FormlyFieldProps,
  FormlyModule,
} from '@ngx-formly/core';
import { PhoneFormatDirective, VectronicValidators } from '@vectronic/util';
import { CustomErrorStateMatcher } from '../../utils/custom-error-state-matcher';

interface PhoneProps extends FormlyFieldProps {
  mobileOnly?: boolean;
  prefixText?: string;
  suffixText?: string;
}

export interface FormlyPhoneFieldConfig extends FormlyFieldConfig<PhoneProps> {
  type: 'phone' | Type<PhoneComponent>;
}

@Component({
  selector: 'vectronic-formly-phone',
  imports: [
    MatFormFieldModule,
    FormlyModule,
    ReactiveFormsModule,
    MatInputModule,
    PhoneFormatDirective,
  ],
  template: `
    @if (props) {
      <mat-form-field>
        <mat-label>{{ props.label }}</mat-label>
        <input
          matInput
          [id]="id"
          [name]="field.name"
          [type]="props.type"
          [readonly]="props.readonly"
          [required]="props.required"
          [formControl]="formControl"
          [formlyAttributes]="field"
          [tabIndex]="props.tabindex"
          [placeholder]="props.placeholder"
          [errorStateMatcher]="matcher"
          vectronicPhoneFormat
        />
        <mat-error>
          <formly-validation-message [field]="field"></formly-validation-message>
        </mat-error>
        @if (props.prefixText) {
          <span matTextPrefix>{{ props['prefixText'] }}</span>
        }
        @if (props.suffixText) {
          <span matTextSuffix>{{ props['suffixText'] }}</span>
        }
      </mat-form-field>
    }
  `,
  styles: [
    `
      mat-form-field {
        display: block;
      }

      span[matTextSuffix] {
        margin-left: 0.5rem;
      }

      span[matTextPrefix] {
        margin-right: 0.5rem;
      }
    `,
  ],
})
export class PhoneComponent extends FieldType<FieldTypeConfig<PhoneProps>> implements OnInit {
  matcher = new CustomErrorStateMatcher();

  ngOnInit() {
    if (this.props.mobileOnly) {
      this.formControl.addValidators(VectronicValidators.mobilePhone);
    } else {
      this.formControl.addValidators(VectronicValidators.phone);
    }
  }
}
